import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../pages/Login";
import LiveChatLogin from "../pages/LiveChatLogin";
import NotFound from "../pages/NotFound";
import MultiRestaurantDashboard from "../pages/MultiRestaurantDashboard";
import OrderAlertsProvider from "../components/OrderAlertsProvider";
import UpdateWatcher from "../components/UpdateWatcher";
import Control from "../pages/Control";
import { AppContext } from "./AppContext";
import AllOrders from "../pages/AllOrders";
import AddFoodPage from "../pages/AddFoodPage";
import AddRestaurantPage from "../pages/AddRestaurantPage";
import AddTownPage from "../pages/AddTownPage";
import RestaurantsPage from "../pages/RestaurantsPage";
import AddFoodCategoryPage from "../pages/AddFoodCategoryPage";
import AddBillPage from "../pages/AddBillPage";
import RestaurantsOrders from "../pages/RestaurantsOrders";
import Destek from "../pages/Destek";
import TicketDetail from "../pages/TicketDetail";
import TicketSettingsPage from "../pages/TicketSettingsPage";
import TicketSearchPage from "../pages/TicketSearchPage";
import UsersPage from "../pages/UsersPage";
import RentARoomLogin from "../RentARoom/pages/RentARoomLogin";
import RentARoomDashboard from "../RentARoom/pages/RentARoomDashboard";
import RentARoomTalepler from "../RentARoom/pages/RentARoomTalepler";
import RentARoomSiparisler from "../RentARoom/pages/RentARoomSiparisler";
import RentARoomControl from "../RentARoom/components/RentARoomControl";
import SliderPage from "../pages/SliderPage";
import WorkingHoursPage from "../pages/WorkingHoursPage";
import AdminWorkingHoursPage from "../pages/AdminWorkingHoursPage";
import AdminOrderManagementPage from "../pages/AdminOrderManagementPage";
import PaymentMethodsPage from "../pages/PaymentMethodsPage";
import AdminPaymentMethodsPage from "../pages/AdminPaymentMethodsPage";
import RestaurantSettingsPage from "../pages/RestaurantSettingsPage";
import PromoCodesPage from "../pages/PromoCodesPage";
import AdminPromoCodesPage from "../pages/AdminPromoCodesPage";
import FeedbackManagementPage from "../pages/FeedbackManagementPage";
import DriversPage from "../pages/DriversPage";
import AwsPage from "../pages/AwsPage";
import HostingerPage from "../pages/HostingerPage";
import MailManagementPage from "../pages/MailManagementPage";
import DineInManagementPage from "../dinein-module/pages/DineInManagementPage";
import LiveChatAgentPage from "../live-chat-module/pages/LiveChatAgentPage";
import LiveChatManagementPage from "../live-chat-module/pages/LiveChatManagementPage";
import AdminReservationManagementPage from "../reservation-module/pages/AdminReservationManagementPage";
import DriverLogin from "../pages/DriverLogin";
import DriverPanel from "../pages/DriverPanel";
import WaiterLogin from "../pages/WaiterLogin";
import ProfilePage from "../pages/ProfilePage";
import IncidentManagementPage from "../incident-module/pages/IncidentManagementPage";
export const route = (
  <AppContext>
    <BrowserRouter>
      {/* Yeni sürüm yayına çıkınca açık sekmeyi kendiliğinden günceller */}
      <UpdateWatcher />
      {/* Yeni sipariş dinleyicisi: Routes dışında, sayfa değişince bağlantılar kopmasın */}
      <OrderAlertsProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/LiveChatLogin" element={<LiveChatLogin />} />
        <Route path="/DriverLogin" element={<DriverLogin />} />
        <Route path="/WaiterLogin" element={<WaiterLogin />} />
        <Route path="/kuryePaneli" element={<Control item={<DriverPanel />} />} />
        {/* Çok restoranlı hesapta restoran seçici + diğer restoranların sipariş uyarısı; tek restoranlıda düz Dashboard */}
        <Route path="/dashboard" element={<Control item={<MultiRestaurantDashboard />} />} />
        <Route path="/profil" element={<Control item={<ProfilePage />} />} />
        <Route path="/allOrders" element={<Control item={<AllOrders />} />} />
        <Route
          path="/addFoodPage"
          element={<Control item={<AddFoodPage />} />}
        />
        <Route
          path="/restaurantSettings"
          element={<Control item={<RestaurantSettingsPage />} />}
        />
           <Route
          path="/addBillPage"
          element={<Control item={<AddBillPage />} />}
        />
              <Route
          path="/addTownPage"
          element={<Control item={<AddTownPage />} />}
        />
          <Route
          path="/addRestaurantPage"
          element={<Control item={<AddRestaurantPage />} />}
        />
         <Route
          path="/addFoodCategoryPage"
          element={<Control item={<AddFoodCategoryPage />} />}
        />
        <Route
          path="/restaurantsPage"
          element={<Control item={<RestaurantsPage />} />}
        />
        <Route
          path="/restaurantsOrders"
          element={<Control item={<RestaurantsOrders />} />}
        />
        <Route path="/destek" element={<Control item={<Destek />} />} />
        <Route path="/ticketSettings" element={<Control item={<TicketSettingsPage />} />} />
        <Route path="/ticketSearch" element={<Control item={<TicketSearchPage />} />} />
        <Route path="/usersPage" element={<Control item={<UsersPage />} />} />
        <Route path="/ticket/:id" element={<Control item={<TicketDetail />} />} />
        <Route path="/sliderPage" element={<Control item={<SliderPage />} />} />
        <Route path="/paymentMethods" element={<Control item={<PaymentMethodsPage />} />} />
        <Route path="/adminPaymentMethods" element={<Control item={<AdminPaymentMethodsPage />} />} />
        <Route path="/adminOrderManagement" element={<Control item={<AdminOrderManagementPage />} />} />
        <Route path="/workingHours" element={<Control item={<WorkingHoursPage />} />} />
        <Route path="/adminWorkingHours" element={<Control item={<AdminWorkingHoursPage />} />} />
        <Route path="/promoCodes" element={<Control item={<PromoCodesPage />} />} />
        <Route path="/adminPromoCodes" element={<Control item={<AdminPromoCodesPage />} />} />
        <Route path="/feedbackManagement" element={<Control item={<FeedbackManagementPage />} />} />
        <Route path="/drivers" element={<Control item={<DriversPage />} />} />
        <Route path="/aws" element={<Control item={<AwsPage />} />} />
        <Route path="/hostinger" element={<Control item={<HostingerPage />} />} />
        <Route path="/mailManagement" element={<Control item={<MailManagementPage />} />} />
        <Route path="/dineIn" element={<Control item={<DineInManagementPage key="all" />} />} />
        {/* Navbardaki Salon Siparişi: kullanıcının bağlı olduğu restoran (salon rolü gerekir) */}
        <Route path="/salon" element={<Control item={<DineInManagementPage key="own" mode="own" />} />} />
        <Route path="/garson" element={<Control item={<DineInManagementPage key="waiter" mode="waiter" />} />} />
        <Route path="/liveChat" element={<Control item={<LiveChatAgentPage />} />} />
        <Route path="/liveChatManagement" element={<Control item={<LiveChatManagementPage />} />} />
        <Route path="/adminReservationManagement" element={<Control item={<AdminReservationManagementPage />} />} />
        <Route path="/incidentManagement" element={<Control item={<IncidentManagementPage />} />} />

        {/* RentARoom module */}
        <Route path="/rentaroom" element={<RentARoomLogin />} />
        <Route path="/rentaroom/dashboard"  element={<RentARoomControl item={<RentARoomDashboard />} />} />
        <Route path="/rentaroom/talepler"   element={<RentARoomControl item={<RentARoomTalepler />} />} />
        <Route path="/rentaroom/siparisler" element={<RentARoomControl item={<RentARoomSiparisler />} />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      </OrderAlertsProvider>
    </BrowserRouter>
  </AppContext>
);
